<template>
  <div>
    <input
      :id="nome"
      type="file"
      :accept="accept"
      style="display: none"
      :disabled="disabled"
      @change="handleFileInput"
    >
    <a
      key=""
      href="#"
      @click.prevent="selectFile"
    >
      <div
        :class="dropZoneClass"
        @drop="dropHandler"
        @dragover.prevent="dragOverHandler"
      >
        <v-icon
          size="30"
          :class="iconClass"
        >{{ fileName && !disabled ? 'check_circle' : 'upload_file' }}</v-icon>
        <br>
        <p :class="!disabled ? 'truncate-text' : 'truncate-text-disable'">
          {{ nome }}<br>
          {{ fileName }}
        </p>
      </div>
      <p
        v-if="fileErro"
        class="erro"
      >Por favor selecione {{ nome }}</p>
      <p
        v-if="fileTypeErro && isFoto"
        class="erro"
      >
        Arquivo inválido. Enviar documento do tipo Jpg*
      </p>
      <p
        v-if="fileTypeErro && !isFoto"
        class="erro"
      >
        Arquivo inválido. Enviar documento do tipo {{ typeFileRequired }} *
      </p>
      <p
        v-if="errorSize"
        class="erro"
      >
        Arquivo inválido. Enviar documento com tamanho de até 5MB*
      </p>
    </a>
  </div>
</template>

<script>
export default {
  name: 'UploadFile',
  props: {
    nome: {
      type: String,
      default: '',
    },
    isFoto: {
      type: Boolean,
      default: false,
    },
    fileErro: {
      type: Boolean,
      default: false,
    },
    fileTypeErro: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fileName: {
      type: String,
      default: '',
    },
    typeFileRequired: {
      type: String,
      default: 'PDF, Png ou Jpg',
    },
    accept: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    errorSize: false,
  }),
  computed: {
    dropZoneClass() {
      if (this.disabled) {
        return 'drop-zone-disable';
      }

      return this.fileName ? 'drop_zone_filled' : 'drop_zone';
    },
    iconClass() {
      if (this.disabled) {
        return 'icon';
      }

      return this.fileName ? 'icon-success' : '';
    },
  },
  methods: {
    dragOverHandler(event) {
      event.preventDefault();
    },
    dropHandler(event) {
      event.preventDefault();
      if (
        !this.disabled &&
        event.dataTransfer.items.length === 1 &&
        event.dataTransfer.items[0].kind === 'file'
      ) {
        const file = event.dataTransfer.items[0].getAsFile();
        if (file.size > 5242880) {
          this.errorSize = true;
        } else {
          this.$emit('file', file);
          this.errorSize = false;
        }
      }
      this.removeDragData(event);
    },
    selectFile() {
      !this.disabled && document.getElementById(`${this.nome}`).click();
    },
    handleFileInput(event) {
      if (event.target.files[0]) {
        const file = event.target.files[0];
        if (file.size > 5242880) {
          this.errorSize = true;
        } else {
          this.$emit('file', file);
          this.errorSize = false;
        }
      }
    },
    removeDragData(event) {
      if (event.dataTransfer.items) {
        event.dataTransfer.items.clear();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.drop_zone {
  border: 1px dashed #444a4c;
  border-radius: 4px;
  width: 99%;
  height: 100px;
  padding-top: 8px;
  margin-left: 1.5px;
  text-align: center;
  background-color: #edebeb;
  margin-top: -5px;
  margin-bottom: 12px;
}
.drop-zone-disable {
  border: 1px dashed #969999;
  border-radius: 4px;
  width: 99%;
  height: 100px;
  padding-top: 8px;
  margin-left: 1.5px;
  text-align: center;
  background-color: #edebeb;
  margin-top: -5px;
  margin-bottom: 12px;
}
.drop_zone_filled {
  border: 1px solid #2e7d32;
  border-radius: 4px;
  width: 99%;
  height: 100px;
  padding-top: 8px;
  margin-left: 1.5px;
  text-align: center;
  background-color: #e8f5e9;
  margin-top: -5px;
  margin-bottom: 12px;
}
.truncate-text {
  color: #444a4c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 4px;
}
.truncate-text-disable {
  color: #828484;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 4px;
}
.erro {
  color: #f61a1a;
  font-size: 11.5px;
  margin-top: -10px;
  padding-left: 8px;
}
.icon {
  color: #828484;
}
.icon-success {
  color: #2e7d32;
}
</style>
